import { MutationTree } from "vuex";
import { ForexState } from "@/feature/Forex/store/interface";
import { ForexMutation } from "@/feature/Forex/store/constants";
import { ForexCount, ForexCourseByType } from "@/feature/Forex/api/forex.interface";

export default <MutationTree<ForexState>> {

	[ForexMutation.setCount](state, forexCount: ForexCount) {
		state.draftsCount = forexCount.draft;
		state.templatesCount = forexCount.template;
	},

	[ForexMutation.setCourse](state, course: ForexCourseByType) {
		state.courseBuy = course.buy;
		state.courseSell = course.sell;
	},

	[ForexMutation.resetCourse](state) {
		state.courseBuy = [];
		state.courseSell = [];
	},

}